export default {

	init() {
		console.log('init drawer...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$(document).on('click', 'a[href="#contact-drawer"]', function(e){
			e.preventDefault();
			Drawer.handleDrawerTriggerClick();
		});

		$('#contact-drawer-wrapper .contact-drawer-heading').on('click', function(e){
			const parentDiv = $('#contact-drawer-wrapper');
			if(!parentDiv.hasClass('expanded')) {
				Drawer.handleDrawerHeadingClick();
			} else {
				if($(e.target).closest('.contact-drawer-heading-close').length) Drawer.handleDrawerHeadingClick();
			}
		});

		$('#contact-drawer-wrapper .contact-drawer-bg').on('click', function(e){
			const parentDiv = $('#contact-drawer-wrapper');
			if(parentDiv.hasClass('expanded')) {
				Drawer.handleDrawerHeadingClick();
			}
		});

		$('#contact-drawer-wrapper .drawer-page-intro-phone-number input').on('keydown', function(e){
			var regex = /[0-9]|\-/;
			if(!regex.test(e.key) && e.key != 'Backspace' && e.key != 'Delete') {
				e.preventDefault();
			} else {
				const el = $(this);
				el.val(el.val().replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3"));
				setTimeout(function(){
					validatePhoneFieldButton(el);
				}, 50);
			}
		});

		$('#contact-drawer-wrapper .drawer-page-intro-phone-number input').on('change', function(e){
			const el = $(this);
			el.val(el.val().replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3"));
			setTimeout(function(){
				validatePhoneFieldButton(el);
			}, 50);
		});

		function validatePhoneFieldButton(el) {
			if(el.val().length == 12) {
				el.closest('.drawer-page-intro-bottom').find('a').removeClass('disabled');
			} else {
				el.closest('.drawer-page-intro-bottom').find('a').addClass('disabled');
			}
		}

		$('#contact-drawer-wrapper a[target-drawer-page-number]').on('click', function(e){
			e.preventDefault();
			if($(this).hasClass('disabled')) {
				window.alert('Please enter a phone number to proceed');
			} else {
				const pageNum = $(this).attr('target-drawer-page-number');
				const drawerBodyInner = $(this).closest('.contact-drawer-body-inner');

				if(pageNum == 'back') {
					// const drawerPage = $(this).closest('.drawer-page');
					// const drawerPageContent = drawerPage.attr('content');
					// if(drawerPageContent) {
					// 	drawerPage.find('.drawer-page-content').html(atob(drawerPageContent));
					// } else {
					// 	//If FormAssembly, return to page 1
					// 	drawerPage.find('form .wfCurrentPage').removeClass('wfCurrentPage').addClass('wfPage');
					// 	drawerPage.find('#wfPgIndex-1').removeClass('wfPage').addClass('wfCurrentPage');
					// }
					drawerBodyInner.attr('drawer-page-showing', '');
				} else {
					drawerBodyInner.attr('drawer-page-showing', pageNum);
				}

				$('#contact-drawer-wrapper.new').removeClass('new').addClass('started');
			}
		});

		$('#contact-drawer-wrapper').on('submit', '.wForm form', function(e){
			// e.preventDefault();
			$('#contact-drawer-wrapper.started').removeClass('started').addClass('completed');
		});

		window.addEventListener("message", function (event) {
		    if(event.data.event === "calendly.event_scheduled") {
				$('#contact-drawer-wrapper.started').removeClass('started').addClass('completed');
		        console.log('event_scheduled');
		    }
		});

		$('.drawer-page-intro-phone-number > input').on('change', function(){
			const formattedValue = $(this).val().replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3");
			$(this).val(formattedValue);

			const phoneField = $('.contact-drawer .inputWrapper input[title="Phone Number"]');
			if(phoneField.length) {
				phoneField.each(function(){
					$(this).val(formattedValue).closest('.oneField').addClass('focused');
				});
			}
		});

	    setTimeout(function(){
	    	const selector = $('a[href="#"][data-bs-toggle][data-bs-target]');
	    	// console.log(selector);

			selector.each(function(){
				$(this).attr('href', '#contact-drawer');
				$(this).attr('data-bs-toggle', '');
				$(this).attr('data-bs-target', '');
				$(this).attr('aria-controls', '');
			});
	    }, 1000);
	},

	handleDrawerTriggerClick() {
		console.log('clicked!');
		if($('#contact-drawer-wrapper').length) {
			$('#contact-drawer-wrapper').addClass('expanded');
		}
	},

	handleDrawerHeadingClick() {
		$('#contact-drawer-wrapper').toggleClass('expanded');
	}

};
